// import { ref, computed } from "vue";
import { defineStore } from 'pinia'

import { loginState } from '@/stores/loginstore/loginState.js'
import { loginGetters } from '@/stores/loginstore/loginGetters.js'
import { loginActions } from '@/stores/loginstore/loginActions.js'

export const loginStore = defineStore('loginstore', {
  state: () => loginState,
  getters: loginGetters,
  actions: loginActions
})

export default loginStore
